import { render } from "./TokenChart.vue?vue&type=template&id=11acf390&scoped=true"
import script from "./TokenChart.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenChart.vue?vue&type=script&setup=true&lang=js"

import "./TokenChart.vue?vue&type=style&index=0&id=11acf390&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11acf390"],['__file',"resources/js/components/TokenChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11acf390"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11acf390', __exports__)) {
    api.reload('11acf390', __exports__)
  }
  
  module.hot.accept("./TokenChart.vue?vue&type=template&id=11acf390&scoped=true", () => {
    api.rerender('11acf390', render)
  })

}


export default __exports__